var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-226.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(226.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4983",
    "data-name": "Path 4983",
    d: "M13,0A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat-2",
    "data-name": "Flat",
    transform: "translate(4.794 12.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    d: "M1,1.217a15.334,15.334,0,0,0,7.339.551,20.22,20.22,0,0,1,6-.735,14.694,14.694,0,0,1,3.069.551",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEven);
export default __webpack_public_path__ + "static/media/even.fef7897706fe9bb0df6dc77259d0ce19.svg";
export { ForwardRef as ReactComponent };